module.exports = __webpack_public_path__ + "static/media/slika3.7ab72481.png";